<template>
  <div class="overflow-y-scroll h-[650px]">
    <UHeader class="z-1 w-full rounded-t-md">
      <template #title>
        <svg
          class="h-6 w-auto"
          width="109"
          height="28"
          viewBox="0 0 109 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        ><path d="M51.4076 27.4454C51.698 27.4454 51.9454 27.2046 51.9454 26.9076V14.4034C51.9454 14.4034 52.6177 15.6135 53.8278 17.6303L59.0715 26.6387C59.3114 27.1416 59.8437 27.4454 60.2815 27.4454H63.9118V7.27734H60.2815C60.0398 7.27734 59.7437 7.47823 59.7437 7.81516V20.4538L57.3236 16.1513L52.4832 7.94961C52.2477 7.53163 51.7409 7.27734 51.2731 7.27734H47.7773V27.4454H51.4076Z" fill="white" /><path d="M98.332 12.9244H100.08C100.525 12.9244 100.887 12.5632 100.887 12.1177V8.62188H104.651V12.9244H108.282V16.1513H104.651V21.9328C104.651 23.3446 105.331 23.9496 106.534 23.9496H108.282V27.4454H105.996C102.896 27.4454 100.887 25.4382 100.887 22.0673V16.1513H98.332V12.9244Z" fill="white" /><path d="M80.1807 12.9244V21.2605C80.1807 23.1434 79.4738 24.7307 78.4328 25.832C77.3918 26.9332 75.9543 27.4454 73.9958 27.4454C72.0374 27.4454 70.4654 26.9332 69.4244 25.832C68.4011 24.7307 67.6765 23.1434 67.6765 21.2605V12.9244H69.8278C70.2865 12.9244 70.7379 13.008 71.0378 13.3278C71.3378 13.6297 71.4412 13.8071 71.4412 14.2689V21.2605C71.4412 22.3441 71.5026 23.0134 71.979 23.5462C72.4554 24.0614 73.0431 24.2185 73.9958 24.2185C74.9662 24.2185 75.4018 24.0614 75.8782 23.5462C76.3546 23.0134 76.416 22.3441 76.416 21.2605V14.2689C76.416 13.8071 76.5194 13.513 76.8194 13.1933C77.0829 12.9124 77.3609 12.919 77.7605 12.9244C77.8158 12.9251 77.9738 12.9244 78.0294 12.9244H80.1807Z" fill="white" /><path d="M91.6093 19.916L96.1807 12.9244H92.6849C92.2443 12.9244 91.8529 13.0825 91.6093 13.4622L89.458 16.6891L87.4412 13.5967C87.1976 13.2169 86.6717 12.9244 86.2311 12.9244H82.8698L87.4412 19.7815L82.4664 27.4454H85.9622C86.3992 27.4454 86.7934 27.0134 87.0378 26.6387L89.458 23.0084L92.0126 26.7731C92.257 27.1479 92.6512 27.4454 93.0883 27.4454H96.5841L91.6093 19.916Z" fill="white" /><path d="M23.307 27.4454H38.2314C38.7076 27.4455 39.1634 27.2781 39.5759 27.0421C39.9883 26.806 40.4135 26.5097 40.6515 26.1009C40.8896 25.6921 41.0551 25.2283 41.0549 24.7562C41.0547 24.2842 40.8899 23.8206 40.6515 23.4119L30.5675 6.06729C30.3295 5.65855 30.0387 5.36211 29.6263 5.12612C29.214 4.89012 28.6235 4.72275 28.1473 4.72275C27.6711 4.72275 27.2151 4.89012 26.8028 5.12612C26.3904 5.36211 26.0996 5.65855 25.8616 6.06729L23.307 10.5043L18.1977 1.89891C17.9595 1.4902 17.669 1.05955 17.2566 0.823595C16.8441 0.58764 16.3883 0.554687 15.912 0.554688C15.4358 0.554687 14.98 0.58764 14.5675 0.823595C14.155 1.05955 13.7301 1.4902 13.4919 1.89891L0.987658 23.4119C0.749268 23.8206 0.718957 24.2842 0.71875 24.7562C0.718543 25.2283 0.749627 25.692 0.987658 26.1008C1.22569 26.5097 1.65084 26.806 2.06329 27.0421C2.47573 27.2781 2.93156 27.4455 3.40783 27.4454H12.8196C16.5489 27.4454 19.2633 25.7725 21.1557 22.6051L25.7272 14.6723L28.1473 10.5043L35.5423 23.1429H25.7272L23.307 27.4454ZM12.6851 23.1429H6.0969L15.912 6.20175L20.8868 14.6723L17.5915 20.4169C16.3348 22.472 14.902 23.1429 12.6851 23.1429Z" fill="#00DC82" /></svg>
      </template>

      <UNavigationMenu
        :items="[
          {
            label: 'Docs'
          },
          {
            label: 'Components'
          },
          {
            label: 'Figma'
          },
          {
            label: 'Releases'
          }
        ]"
      />

      <template #right>
        <UColorModeButton />

        <UTooltip text="Open on GitHub" :kbds="['meta', 'G']">
          <UButton
            color="neutral"
            variant="ghost"
            to="https://github.com/nuxt/ui"
            target="_blank"
            icon="i-simple-icons-github"
            aria-label="GitHub"
          />
        </UTooltip>
      </template>
    </UHeader>
    <UPageHero
      title="Nuxt UI - Starter"
      description="Nuxt UI is a free and open-source UI library for Nuxt applications. Create beautiful & responsive applications in minutes."
      :links="[{
        label: 'Get started',
        to: 'https://ui.nuxt.com/getting-started/installation/nuxt',
        target: '_blank',
        trailingIcon: 'i-lucide-arrow-right',
        size: 'xl'
      }, {
        label: 'Use this template',
        to: 'https://github.com/nuxt-ui-templates/starter',
        target: '_blank',
        icon: 'i-simple-icons-github',
        size: 'xl',
        color: 'neutral',
        variant: 'subtle'
      }]"
    />

    <UPageSection
      id="features"
      title="The freedom to build anything"
      description="Nuxt UI ships with a comprehensive set of components that cover a wide range of use-cases. Carefully crafted to reduce boilerplate code without sacrificing flexibility."
      :features="[{
        icon: 'i-lucide-wrench',
        title: 'Fully customizable',
        description: 'Customize any component through the App Config or fine-tune specific instances with the ui prop for maximum flexibility.'
      }, {
        icon: 'i-lucide-square-stack',
        title: 'Powerful slot system',
        description: 'Take full control of component layouts and content with Vue\'s comprehensive slot system for maximum flexibility.'
      }, {
        icon: 'i-lucide-smartphone',
        title: 'Mobile-first & responsive',
        description: 'Built with a mobile-first approach, all components automatically adapt to any screen size while maintaining a polished look.'
      }]"
    />

    <UPageSection title="Pricing">
      <UPricingPlans
        :plans="[
          {
            title: 'Starter',
            description: 'Perfect for personal projects and small teams.',
            price: 'Free',
            features: [
              'All 110+ components',
              'Complete Figma kit',
              '12 free templates',
              'Community support'
            ],
            button: {
              label: 'Get started'
            }
          },
          {
            title: 'Pro',
            description: 'Enhanced features for growing businesses.',
            price: '$19',
            billingCycle: '/month',
            features: [
              'Everything in Starter',
              'Priority support',
              'Advanced templates',
              'Custom components'
            ],
            button: {
              label: 'Get started'
            }
          },
          {
            title: 'Enterprise',
            description: 'Tailored solutions for large organizations.',
            price: 'Custom',
            features: [
              'Everything in Pro',
              'Dedicated support',
              'Custom development',
              'SLA guarantee'
            ],
            button: {
              label: 'Contact us',
              variant: 'outline'
            }
          }
        ]"
      />
    </UPageSection>

    <UPageSection>
      <UPageCTA
        title="Start with Nuxt UI today!"
        description="Nuxt UI is a free and open-source UI library for Nuxt applications."
        variant="subtle"
        :links="[{
          label: 'Get started',
          to: 'https://ui.nuxt.com/getting-started/installation/nuxt',
          target: '_blank',
          icon: 'i-lucide-arrow-right',
          color: 'neutral'
        }, {
          label: 'GitHub',
          to: 'https://github.com/nuxt-ui-templates/starter',
          target: '_blank',
          trailingIcon: 'i-simple-icons-github',
          color: 'neutral',
          variant: 'subtle'
        }]"
      />
    </UPageSection>
    <UFooter>
      <template #left>
        <p class="text-muted text-sm">
          Copyright © {{ new Date().getFullYear() }}
        </p>
      </template>

      <UNavigationMenu
        :items="[
          {
            label: 'Figma Kit'
          },
          {
            label: 'Playground'
          },
          {
            label: 'Releases'
          }
        ]"
        variant="link"
      />

      <template #right>
        <UButton
          icon="i-simple-icons-discord"
          color="neutral"
          variant="ghost"
          to="https://go.nuxt.com/discord"
          target="_blank"
          aria-label="Discord"
        />
        <UButton
          icon="i-simple-icons-x"
          color="neutral"
          variant="ghost"
          to="https://go.nuxt.com/x"
          target="_blank"
          aria-label="X"
        />
        <UButton
          icon="i-simple-icons-github"
          color="neutral"
          variant="ghost"
          to="https://github.com/nuxt/nuxt"
          target="_blank"
          aria-label="GitHub"
        />
      </template>
    </UFooter>
  </div>
</template>
